export enum SongType {
  FREE = 'free',
  CUSTOMIZABLE = 'customizable',
  AI_GENERATED = 'ai_generated',
  STUDIO = 'studio',
  USER_UPLOADED = 'user_uploaded',
}
